import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ApiTask } from "src/api/types";
import useAuth from "src/hooks/selectors/useAuth";
import useVariant from "src/hooks/useVariant";

function useTaskButton(task: ApiTask, registrationHid?: string) {
	const { t } = useTranslation("tasks", {
		keyPrefix: "task-button",
	});
	const auth = useAuth();
	const getLabel = () => {
		if (task.is_deleted) {
			return t("deleted");
		}
		if (auth.type === "student") {
			if (task.is_completed) return t("completed");
			if (task.unread_messages)
				return t("messages", {
					count: task.unread_messages,
				});
			if (!task.is_signed && task.is_accepted) return t("not-signed");
			if (task.is_accepted) return t("accepted");
			if (task.is_denied) return t("denied");
			if (!task.is_accepted || !task.is_denied) return t("pending");
			if (!auth.is_verified) return t("account-pending");
			if (task.is_expired) {
				return t("expired");
			}
		}
		return t("view");
	};

	const getType = () => {
		if (task.is_deleted) return "gray";
		if (auth.type === "company") {
			if (task.type === "DRAFT") return "orange";
			if (task?.is_matched && !task?.is_completed) return "gray";
			if (task.is_completed) return "primary";

			if (task.matched_students && task.amount_of_students)
				if (task.matched_students >= task.amount_of_students)
					return "primary";
				else;
			else if (task.is_matched) return "primary";

			if (task.is_expired) return "gray";
			if (!task.registration_count) return "transparent";

			return "orange";
		}
		if (auth.type === "student") {
			if (!auth.is_verified) return "gray";
			if (task.is_accepted) return "primary";
			if (task.is_denied) return "gray";
			if (task.is_expired) return "gray";
			if (!task.is_accepted || !task.is_denied) return "transparent";
		}

		return "orange";
	};
	const [label, setLabel] = useState(getLabel());
	const [type, setType] = useState(getType() as any);
	const to = `/tasks/${task.hid}/show${
		registrationHid ? `/${registrationHid}` : ""
	}`;
	const variant = useVariant(type || "primary");

	useEffect(() => {
		setLabel(getLabel());
		setType(getType());
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [task]);

	return {
		to,
		label,
		type,
		variant,
	};
}

export default useTaskButton;
